/**
 * @generated SignedSource<<1ef6240c4f099ad58319ec9ff41e34d0>>
 * @relayHash 102b6714121e1aee58c2242d61b69e51
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bda61597276eba46553893c1d70d917d5b1d0c2a4ef11816a954240f0b79a704

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardQuery } from './src_jiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bda61597276eba46553893c1d70d917d5b1d0c2a4ef11816a954240f0b79a704",
    "metadata": {},
    "name": "src_jiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
